import { SectionContainer } from 'components/DetailsView/Section/SectionContainer';

import { GetMicrostoreColumnQuery, ProductArrangementReassortmentType, TotadminPermission } from 'data/__generated__';

import { TrayLocationsContent } from './TrayLocationsContent';

type MicrostoreColumn = GetMicrostoreColumnQuery['microstoreColumn'];

export const TrayLocationsSection = ({ microstoreColumn }: { microstoreColumn: MicrostoreColumn }) => {
    const hasTrayLocations = microstoreColumn.shelves.some((shelf) =>
        shelf.locationTable.some((row) =>
            row.some(
                (loc) => loc.microstoreLocationTemplate?.reassortmentType === ProductArrangementReassortmentType.Tray,
            ),
        ),
    );

    if (!hasTrayLocations) {
        return null;
    }

    return (
        <SectionContainer
            title="Gestion des bacs"
            isInitiallyOpen
            requiredPermissions={[TotadminPermission.TrayCapacitiesRead]}
        >
            <TrayLocationsContent microstoreColumn={microstoreColumn} />
        </SectionContainer>
    );
};
